const LaunchArguments = {
    value: () => ({}),
};

export { LaunchArguments };
